import { find, findIndex } from 'lodash';
import PureGameElement     from '../../tools/PureGameElement';
import GooseberryJuice     from '../../../assets/font/GooseberryJuice.woff';
import { pad }             from '../../tools/functions';
import {
    gameWindowSize,
    scoreAnimal,
    scoreCouple,
    scoreNewAnimal,
    displayScoreDigit
}                          from '../../constants/appConstants';
import { animalsAssets }   from '../../constants/animalAssets';

class ScoreManager extends PureGameElement {
    constructor ( scene ) {
        super( scene );
        this._text = null;
        this._score = 0;
        this._collectedAnimals = {};

        this.loadFonts();
    }

    async loadFonts () {
        const font = new FontFace( 'gooseberryJuice', `url("${GooseberryJuice}")` );
        await font.load();
        document.fonts.add( font );
    }

    get displayScore () {
        return pad( Math.floor( this._score ), displayScoreDigit );
    }

    get width () {
        return gameWindowSize.width / 2;
    }

    preload () {
        super.preload();
    }

    create () {
        super.create();
        this._text = this.scene.add.text( this.width, 0, this.displayScore, { font: '25px gooseberryJuice' } );
        this._text.setOrigin( 0.5, 0 );
        this._text.depth = 10;

    }

    addCollectedAnimal ( animalId ) {
        const animalConfig = find( animalsAssets, { id: animalId } );
        if ( !animalConfig ) return;

        if ( !this._collectedAnimals[animalId] ) {
            this._score += animalConfig.rarity * scoreNewAnimal;
            this._collectedAnimals[animalId] = { count: 0, totalWeight: 0 };
        } else if ( this._collectedAnimals[animalId].count === 1 ) {
            this._score += animalConfig.rarity * scoreCouple;
        } else {
            this._score += animalConfig.rarity * scoreAnimal;
        }

        this._collectedAnimals[animalId].count++;
        this._collectedAnimals[animalId].totalWeight += animalConfig.weight;
        this._text.setText( this.displayScore );
    }

}

export default ScoreManager;
